import type { Example } from "../types";
import code from "./code.js" with { type: "text" };
import golden from "./golden.json";

export const storageHoarder: Example = {
  id: "storage-hoarder",
  title: "Storage hoarding",
  group: "technique",
  environment: "browser",
  mode: "script",
  summary: "Dumps localStorage, sessionStorage, and IndexedDB, then beacons it out",
  explainer:
    "Watch the STORAGE events: enumerating `localStorage`, reading every key (including the `auth_token`), walking `sessionStorage` by index, and listing IndexedDB databases. The dump leaves in a single `sendBeacon`, whose body is in the event's details. The `auth_token` the page stores is this run's JWT-shaped canary, so the beacon is badged `canary` and the Report shows a critical flow `localStorage:auth_token → telemetry.cdn-assets.example`.",
  code,
  expect: golden as Example["expect"],
};
